import { Modal } from 'react-bootstrap'
interface IReasonsModal {
    type: number
    isOpen: boolean
}
interface IModalProps {
    show: boolean
    onHide: () => void
    setType: React.Dispatch<React.SetStateAction<IReasonsModal>>
}
export default function WithDrawTypeModal({
    show,
    onHide,
    setType,
}: IModalProps) {
    return (
        <Modal
            show={show}
            onHide={onHide}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <div className="">
                <p className=" text-center text-sm py-3">
                    نوع برداشت را انتخاب کنید
                </p>
                <hr />
            </div>
            <div className=" ">
                <p
                    className=" text-center text-sm py-3"
                    onClick={() => {
                        onHide()
                        setType({ type: 0, isOpen: true })
                    }}
                >
                    برداشت سرمایه شخصی
                </p>
                <hr />
            </div>
            <div className=" ">
                <p
                    className=" text-center text-sm py-3"
                    onClick={() => {
                        onHide()
                        setType({ type: 1, isOpen: true })
                    }}
                >
                    عودت قرض مدت دار، واریز اشتباه یا اضافه
                </p>
                <hr />
            </div>
            <div className=" ">
                <p
                    className=" text-center text-sm py-3"
                    onClick={() => {
                        onHide()
                        setType({ type: 2, isOpen: true })
                    }}
                >
                    برنامه های جانبی فرهنگی و امور خیریه بلاعوض
                </p>
                <hr />
            </div>
            <div className=" ">
                <p
                    className=" text-center text-sm py-3"
                    onClick={() => {
                        onHide()
                        setType({ type: 3, isOpen: true })
                    }}
                >
                    تامین مالی هزینه کرد از محل درآمد صندوق
                </p>
                <hr />
            </div>
            <div className=" ">
                <p
                    className=" text-center text-sm py-3"
                    onClick={() => {
                        onHide()
                        setType({ type: 4, isOpen: true })
                    }}
                >
                    سایر
                </p>
                <hr />
            </div>
            <div className=" ">
                <p
                    className=" text-center text-sm py-3 text-green-1 "
                    onClick={onHide}
                >
                    تایید
                </p>
            </div>
        </Modal>
    )
}
